module.exports = __webpack_public_path__ + "img/9788976829672.741333a1.jpg";